import Sentry from "@similarweb/sentry-logger";

import { DefaultFetchService } from "app/services/fetchService";

export interface IInitialTopicsResponse {
    country: number;
    topics: string[];
}

export interface IInitialTopicsParams {
    domain: string;
    userId: number;
    country?: number;
    cultureName?: string;
}

const API_PATH = "/api/aiTracker/topics";

export const getTopics = async (params: IInitialTopicsParams): Promise<IInitialTopicsResponse> => {
    try {
        const fetchService = DefaultFetchService.getInstance();
        const response = await fetchService.post(API_PATH, params);
        return response as IInitialTopicsResponse;
    } catch (error) {
        Sentry.errorTracker({
            e: error,
            message: "Error fetching topics from AI Tracker API",
            level: "error",
            params: {
                extra: { ...params },
            },
        });
    }
};
